export default function TwitterIcon({
  size = 30,
  width,
  height,
  ...rest
}: {
  size?: number;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width || size}
      height={height || width}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM22.7157 7.50083H20.0323L15.6104 12.5554L11.7872 7.50083H6.25L12.8662 16.1523L6.59555 23.3192H9.28065L14.1202 17.7893L18.3498 23.3192H23.75L16.8532 14.2013L22.7157 7.50083ZM20.5774 21.713H19.0905L9.38366 9.02263H10.9793L20.5774 21.713Z"
        fill="white"
      />
    </svg>
  );
}
